// Mock data for Julie Masse - Amma Assis website

export const businessInfo = {
  name: "Julie Masse",
  siret: "93039026500013",
  location: "Malafretaz (01340)",
  email: "contact@juliemasse-amma.fr",
  phone: "06 07 31 46 10",
  tagline: "Bien-être au travail par le Amma assis"
};

export const heroContent = {
  title: "Amma Assis en entreprise",
  titleHighlight: "Bien-être du salarié",
  description: "Séances rapides, efficaces et adaptées aux environnements professionnels. Interventions sur site (Malafretaz et environs).",
  ctaPrimary: "Découvrir l'Amma assis",
  ctaPrimaryLink: "/amma-assis",
  ctaSecondary: "Demander un devis entreprise",
  ctaSecondaryLink: "/contact"
};

export const hrTrustBadges = [
  {
    id: 1,
    title: "Massage habillé",
    description: "Aucune contrainte vestimentaire",
    icon: "Shirt",
  },
  {
    id: 2,
    title: "15–20 min",
    description: "Par salarié",
    icon: "Clock",
  },
  {
    id: 3,
    title: "Installation rapide",
    description: "5 minutes seulement",
    icon: "Zap",
  },
  {
    id: 4,
    title: "Tous espaces",
    description: "Bureaux, open space, salle de pause",
    icon: "Building2",
  },
];

export const trustBadges = [
{
  id: 1,
  title: "Diplôme d'État",
  description: "Aide-soignante",
  icon: "GraduationCap"
},
{
  id: 2,
  title: "Médecine alternative",
  description: "Formation certifiée",
  icon: "Heart"
},
{
  id: 3,
  title: "Amma assis",
  description: "Spécialiste certifiée",
  icon: "Award"
},
{
  id: 4,
  title: "Déplacement",
  description: "Malafretaz et environs",
  icon: "MapPin"
}];


export const ammaAssisSummary = {
  title: "Qu'est-ce que le Amma assis ?",
  description: "Le Amma assis est une technique de massage japonaise pratiquée sur une chaise ergonomique spéciale. Habillé et assis, le bénéficiaire reçoit un enchaînement précis de pressions, étirements et balayages sur le dos, les épaules, les bras et la tête. En seulement 15 à 25 minutes, cette méthode offre une détente profonde et un regain d'énergie immédiat.",
  link: "/amma-assis",
  linkText: "En savoir plus sur le Amma assis"
};

export const benefits = [
{
  id: 1,
  title: "Réduction du stress",
  description: "Diminution immédiate des tensions nerveuses et de l'anxiété.",
  icon: "Brain"
},
{
  id: 2,
  title: "Soulagement des tensions",
  description: "Libération des tensions cervicales et du haut du dos.",
  icon: "Sparkles"
},
{
  id: 3,
  title: "Meilleure concentration",
  description: "Clarté mentale accrue pour une productivité optimale.",
  icon: "Focus"
},
{
  id: 4,
  title: "Regain d'énergie",
  description: "Revitalisation complète en quelques minutes seulement.",
  icon: "Zap"
},
{
  id: 5,
  title: "Amélioration posture",
  description: "Correction des déséquilibres liés à la position assise.",
  icon: "User"
},
{
  id: 6,
  title: "Bien-être général",
  description: "Sensation de légèreté et de sérénité durable.",
  icon: "Smile"
}];


export const interventionSteps = [
{
  id: 1,
  title: "Installation de la chaise",
  description: "Mise en place rapide en 5 minutes dans l'espace prévu.",
  duration: "5 min"
},
{
  id: 2,
  title: "Séance individuelle",
  description: "15 à 20 minutes de massage Amma assis par salarié.",
  duration: "15-20 min"
},
{
  id: 3,
  title: "Massage habillé",
  description: "Sans huile, le salarié reste habillé confortablement.",
  duration: null
},
{
  id: 4,
  title: "Rotation fluide",
  description: "Planning flexible, les salariés passent à tour de rôle.",
  duration: null
},
{
  id: 5,
  title: "Reprise immédiate",
  description: "Retour au travail direct, sans temps de récupération.",
  duration: null
}];

export const faqItems = [
{
  id: 1,
  question: "De combien d'espace ai-je besoin ?",
  answer: "4 à 5 m² suffisent, n'importe quel petit bureau ou salle de pause convient parfaitement."
},
{
  id: 2,
  question: "Combien de salariés peuvent être massés ?",
  answer: "En moyenne 6 à 12 salariés par demi-journée selon la durée choisie pour chaque séance."
},
{
  id: 3,
  question: "Le massage nécessite-t-il une tenue particulière ?",
  answer: "Non, tout se fait habillé, sur chaise ergonomique. Aucune préparation nécessaire."
},
{
  id: 4,
  question: "Intervenez-vous en entreprise uniquement ?",
  answer: "Oui, mes prestations sont dédiées aux entreprises et événements professionnels."
}];


export const aboutContent = {
  title: "À propos de Julie",
  subtitle: "Praticienne en bien-être au travail",
  image: "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5",
  paragraphs: [
  "Diplômée d'État Aide-soignante, j'ai exercé pendant plusieurs années dans l'accompagnement des personnes, développant une écoute attentive et un sens aigu du soin.",
  "Passionnée par les médecines alternatives et le bien-être, j'ai entrepris une reconversion professionnelle vers les techniques de relaxation. Ma formation en Amma assis m'a permis de me spécialiser dans cette méthode japonaise ancestrale, particulièrement adaptée au monde de l'entreprise.",
  "Aujourd'hui, j'interviens directement sur site pour offrir aux salariés des pauses bien-être efficaces et revitalisantes. Mon objectif : améliorer la qualité de vie au travail par des techniques rapides, respectueuses et professionnelles."],

  values: [
  { title: "Respect", description: "De chaque personne et de son rythme" },
  { title: "Écoute", description: "Attention aux besoins individuels" },
  { title: "Sérénité", description: "Créer un espace de calme" },
  { title: "Professionnalisme", description: "Rigueur et bienveillance" }]

};

export const ammaAssisPage = {
  title: "Le Amma Assis",
  subtitle: "Une technique japonaise ancestrale adaptée au monde moderne",
  heroImage: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1",
  description: [
  "Le Amma assis est une forme de massage énergétique d'origine japonaise, pratiqué sur une chaise ergonomique spécialement conçue. Le terme \"Amma\" signifie \"calmer par le toucher\" en japonais.",
  "Cette technique se pratique habillé, en position assise, et ne nécessite aucune huile. Le praticien effectue un enchaînement précis de pressions, pétrissages, percussions, étirements et balayages sur le dos, les épaules, les bras, les mains, la nuque et le crâne.",
  "En 15 à 25 minutes, le Amma assis procure une détente profonde tout en revitalisant l'organisme. C'est la méthode idéale pour les interventions en entreprise : rapide, efficace et sans contrainte logistique."],

  targetAudience: [
  { title: "Salariés de bureau", description: "Position assise prolongée" },
  { title: "Télétravailleurs", description: "Isolement et sédentarité" },
  { title: "Managers", description: "Charge mentale importante" },
  { title: "Personnel soignant", description: "Stress et postures contraignantes" },
  { title: "Équipes projet", description: "Périodes de forte activité" }],

  detailedBenefits: [
  {
    title: "Soulagement des tensions cervicales",
    description: "Libération des contractures au niveau du cou et des trapèzes."
  },
  {
    title: "Détente du haut du dos",
    description: "Relâchement des muscles dorsaux souvent sollicités."
  },
  {
    title: "Amélioration de la posture",
    description: "Rééquilibrage des tensions musculaires liées à la position assise."
  },
  {
    title: "Baisse du stress",
    description: "Diminution du cortisol et activation du système parasympathique."
  },
  {
    title: "Meilleure clarté mentale",
    description: "Amélioration de la concentration et de la prise de décision."
  },
  {
    title: "Regain d'énergie",
    description: "Revitalisation immédiate pour affronter le reste de la journée."
  }]

};

export const prestationsContent = {
  title: "Nos Prestations",
  subtitle: "Des solutions adaptées à vos besoins en entreprise",
  sessionSteps: [
  {
    step: 1,
    title: "Accueil",
    description: "Le salarié est accueilli dans un espace calme et préparé."
  },
  {
    step: 2,
    title: "Explication",
    description: "Présentation rapide du déroulé de la séance."
  },
  {
    step: 3,
    title: "Installation",
    description: "Positionnement confortable sur la chaise ergonomique."
  },
  {
    step: 4,
    title: "Massage",
    description: "Séance de 15 à 20 minutes de Amma assis."
  },
  {
    step: 5,
    title: "Retour",
    description: "Retour progressif à l'activité, revitalisé."
  }],

  businessOffers: [
  {
    title: "Demi-journée",
    description: "Intervention de 3-4 heures pour environ 8-10 salariés.",
    features: ["Installation sur site", "Séances de 20 min", "Rotation fluide"]
  },
  {
    title: "Journée complète",
    description: "Intervention de 7-8 heures pour environ 16-20 salariés.",
    features: ["Installation sur site", "Séances de 20 min", "Pause méridienne"]
  },
  {
    title: "Événements bien-être",
    description: "Journées thématiques ou séminaires d'entreprise.",
    features: ["Sur mesure", "Multi-activités possible", "Devis personnalisé"]
  }]

};

export const entreprisesContent = {
  title: "Interventions en entreprise",
  subtitle: "Investissez dans le bien-être de vos équipes",
  heroImage: "https://images.unsplash.com/photo-1768659347532-74d3b1efb0ae",
  employerBenefits: [
  {
    title: "Réduction du stress",
    description: "Diminution de l'absentéisme lié au stress et à la fatigue.",
    icon: "TrendingDown"
  },
  {
    title: "Amélioration de la posture",
    description: "Soulagement des tensions liées à la position assise prolongée.",
    icon: "User"
  },
  {
    title: "Meilleure concentration",
    description: "Productivité accrue grâce à des équipes plus sereines.",
    icon: "Target"
  },
  {
    title: "Cohésion et climat apaisé",
    description: "Un moment de bien-être partagé qui renforce l'esprit d'équipe.",
    icon: "Heart"
  },
  {
    title: "Geste QVT apprécié",
    description: "Un investissement simple qui valorise votre marque employeur.",
    icon: "Star"
  }],

  logistics: [
  {
    title: "Installation simple",
    description: "Un espace de 4-5 m² suffit pour installer la chaise."
  },
  {
    title: "Discrétion assurée",
    description: "Intervention silencieuse, sans perturbation."
  },
  {
    title: "Aucun équipement requis",
    description: "Le salarié reste habillé, aucune préparation nécessaire."
  },
  {
    title: "Séances rapides",
    description: "15-20 minutes par personne, planification flexible."
  }]

};

export const reviews = [
{
  id: 1,
  name: "Marie D.",
  role: "Responsable RH",
  company: "PME Industrielle",
  rating: 5,
  comment: "Julie est intervenue lors de notre semaine QVT. Les retours des salariés ont été unanimement positifs. Une vraie pause bienfaisante dans leur journée.",
  date: "Mars 2025"
},
{
  id: 2,
  name: "Thomas L.",
  role: "Développeur",
  company: "Startup Tech",
  rating: 5,
  comment: "Après des heures devant l'écran, cette séance de Amma assis m'a complètement détendu. Je me suis senti revigoré pour le reste de la journée.",
  date: "Février 2025"
},
{
  id: 3,
  name: "Sophie M.",
  role: "Directrice",
  company: "Cabinet Comptable",
  rating: 5,
  comment: "Nous faisons appel à Julie une fois par mois. L'ambiance au bureau s'est nettement améliorée et l'équipe attend ces moments avec impatience.",
  date: "Janvier 2025"
},
{
  id: 4,
  name: "Pierre B.",
  role: "Chef de projet",
  company: "Agence Communication",
  rating: 5,
  comment: "Professionnelle, douce et à l'écoute. Julie a su s'adapter aux contraintes de nos locaux et au planning serré de nos équipes.",
  date: "Décembre 2024"
},
{
  id: 5,
  name: "Claire R.",
  role: "Infirmière",
  company: "EHPAD",
  rating: 4,
  comment: "Une vraie bulle de détente dans notre quotidien souvent intense. Les tensions dans le dos et la nuque se sont nettement atténuées.",
  date: "Novembre 2024"
},
{
  id: 6,
  name: "Laurent G.",
  role: "Gérant",
  company: "Artisan local",
  rating: 5,
  comment: "J'ai offert des séances à mes employés pour les fêtes. Un cadeau original et très apprécié ! Julie est très professionnelle.",
  date: "Décembre 2024"
}];


export const averageRating = 4.9;

export const contactInfo = {
  title: "Contactez-moi",
  subtitle: "Pour un devis ou toute question sur mes prestations",
  email: "contact@juliemasse-amma.fr",
  phone: "06 07 31 46 10",
  location: "Malafretaz (01340)",
  zone: "Ain (01) et départements limitrophes",
  availability: "Du lundi au vendredi"
};

export const navigationLinks = [
{ name: "Accueil", path: "/" },
{ name: "Prestations", path: "/prestations" },
{ name: "Amma Assis", path: "/amma-assis" },
{ name: "Entreprises", path: "/entreprises" },
{ name: "À propos", path: "/a-propos" },
{ name: "Avis", path: "/avis" },
{ name: "Contact", path: "/contact" }];


export const images = {
  hero: "https://customer-assets.emergentagent.com/job_julie-relaxation/artifacts/3rvyvzzc_massage-amma-assis-entreprise-lyon-jpg.webp",
  about: "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5",
  ammaAssis: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1",
  entreprises: "https://images.unsplash.com/photo-1768659347532-74d3b1efb0ae",
  wellness: "https://images.unsplash.com/photo-1758874384683-0accd9fb26ee",
  therapy: "https://images.unsplash.com/photo-1745327883389-17150e99dcf7",
  corporate: "https://images.unsplash.com/photo-1754037783933-c25ff9f68f87",
  workplace: "https://images.unsplash.com/photo-1758876020901-043330cd7986"
};